/**
 * Economy SVG icon library — inline SVGs for balance line categories and KPI cards.
 * All icons: 24×24 viewBox, 16×16 rendered, fill="currentColor".
 */

const S = 'viewBox="0 0 24 24" width="16" height="16" fill="currentColor"';

export function iconLegalIncome(): string {
  return `<svg ${S}><path d="M4 20h16v2H4zm0-2h16v-2H4zm2-4h3V8H6zm5 0h3V8h-3zm5 0h3V8h-3zM2 6l10-4 10 4v2H2z"/></svg>`;
}

export function iconExtortion(): string {
  return `<svg ${S}><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm1 15h-2v-2h2v2zm0-4h-2V7h2v5z"/></svg>`;
}

export function iconCybercrime(): string {
  return `<svg ${S}><path d="M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0L19.2 12l-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"/></svg>`;
}

export function iconSubCover(): string {
  return `<svg ${S}><path d="M12 4C9 4 6 5.5 4 8h3c1.5-1.2 3.1-2 5-2s3.5.8 5 2h3c-2-2.5-5-4-8-4zM1 12c0 1.1.3 2.2.8 3.2l2.5-1.5C4.1 13.2 4 12.6 4 12c0-1.7.8-3.2 2-4.2V7c-2.9 1.4-5 4.6-5 5zm7 0a4 4 0 108 0 4 4 0 00-8 0zm4-2a2 2 0 110 4 2 2 0 010-4zm11 2c0-.6-.1-1.2-.3-1.7l-2.5 1.5c.1.4.1.8 0 1.2l2.5 1.5c.2-1 .3-1.7.3-2.5z"/></svg>`;
}

export function iconSalaries(): string {
  return `<svg ${S}><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>`;
}

export function iconRent(): string {
  return `<svg ${S}><path d="M12.65 10a6 6 0 00-6.15-4.95A6.01 6.01 0 001.5 10.5a6 6 0 005.95 6.45c2.05.1 3.9-.7 5.2-2.1l5.85 5.85 1.4-1.4-5.85-5.85c.7-1.15 1.05-2.5.95-3.95a6 6 0 00-2.35-4.5zM7 14.5c-2.49 0-4.5-2.01-4.5-4.5S4.51 5.5 7 5.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5z"/></svg>`;
}

export function iconVehicles(): string {
  return `<svg ${S}><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg>`;
}

export function iconDrones(): string {
  return `<svg ${S}><circle cx="6" cy="6" r="2.5"/><circle cx="18" cy="6" r="2.5"/><circle cx="6" cy="18" r="2.5"/><circle cx="18" cy="18" r="2.5"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" stroke-width="1.5" fill="none"/><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" stroke-width="1.5" fill="none"/><circle cx="12" cy="12" r="2" fill="currentColor"/></svg>`;
}

export function iconFirewall(): string {
  return `<svg ${S}><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1 6h2v2h-2V7zm0 4h2v6h-2v-6z"/></svg>`;
}

export function iconSubs(): string {
  return `<svg ${S}><path d="M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"/></svg>`;
}

export function iconContacts(): string {
  return `<svg ${S}><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/></svg>`;
}

export function iconNetWorth(): string {
  return `<svg ${S}><path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"/></svg>`;
}

export function iconIncome(): string {
  return `<svg ${S}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v-4h3l-4-4-4 4h3v4z"/></svg>`;
}

export function iconExpenses(): string {
  return `<svg ${S}><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-6h2v4h-2zm3-4l-4 4h3v-4h-2z"/></svg>`;
}

export function iconAuditRisk(): string {
  return `<svg ${S}><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>`;
}

function iconFallback(): string {
  return `<svg ${S}><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2"/><text x="12" y="16" text-anchor="middle" font-size="12" fill="currentColor">$</text></svg>`;
}

const CATEGORY_ICON_MAP: Record<string, () => string> = {
  legal_income: iconLegalIncome,
  extortion:    iconExtortion,
  cybercrime:   iconCybercrime,
  sub_cover:    iconSubCover,
  salaries:     iconSalaries,
  rent:         iconRent,
  vehicles:     iconVehicles,
  drones:       iconDrones,
  firewall:     iconFirewall,
  subs:         iconSubs,
  contacts:     iconContacts,
};

export function iconForCategory(category: string | undefined): string {
  if (!category) return iconFallback();
  const fn = CATEGORY_ICON_MAP[category];
  return fn ? fn() : iconFallback();
}

export const CATEGORY_COLORS: Record<string, string> = {
  legal_income: '#3498db',
  extortion:    '#e74c3c',
  cybercrime:   '#9b59b6',
  sub_cover:    '#f39c12',
  salaries:     '#e67e22',
  rent:         '#1abc9c',
  vehicles:     '#2ecc71',
  drones:       '#00cec9',
  firewall:     '#636e72',
  subs:         '#fd79a8',
  contacts:     '#6c5ce7',
};
